import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { formatZonedDateTime } from '../lib/date-formatting';
import {
  getStopDateViolation,
  type StopReasonPolicyDates,
  type StopReasonValidity,
} from './stop-reasons';
import { useTimeZone } from './time-zone';

/** The message the backend's refusal of a stop date would carry, before submitting it. */
export const useStopDateError = (policy: StopReasonPolicyDates) => {
  const { t } = useTranslation();
  const timeZone = useTimeZone();
  return useCallback(
    ({ reason, stopDate }: { reason?: StopReasonValidity; stopDate?: string }) => {
      const violation = reason && stopDate && getStopDateViolation({ reason, policy, stopDate });
      return violation
        ? t(`stopDateValidation.${violation.cause}`, {
            date: formatZonedDateTime(violation.limit, timeZone),
          })
        : undefined;
    },
    [policy, t, timeZone],
  );
};
